import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { editCopyByReplaceMultipleStrings } from '../../../../../components/utilities/copyFunctions';
import {
  getAdults,
  getArrivalDate
} from '../../../../../store/componentStores/ReservationDetailsEntity/reservationDetailsEntity.selectors';
import { DATE_FORMATS } from '../../../../../utilities/constants';
import { getDateMonthDayFormat } from '../../../../../utilities/dates';
import { GwDatesWrapper } from '../../../../_internal_date_/gwDatesWrapper';
import { Modal } from '../../../../Modal';
import { Flex, Text } from '../../../../ui-kit';
import CheckIcon from '../../../../ui-kit/icons/CheckedIcon';
import CloseIcon from '../../../../ui-kit/icons/Close';
import theme from '../../../../ui-kit/themes/theme';
import {
  AppliedContainer,
  CloseButton,
  ContentContainer,
  InfoColumn,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalTitle,
  PassDetailsRow,
  SeasonPassRow,
  SummaryInfoRow,
  TotalRow
} from './styles';
import * as COPY from './utilities/copy';

const propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  arrivalDate: PropTypes.string,
  adults: PropTypes.number,
  reservationDetails: PropTypes.object
};

export const SeasonPassDayPassSummary = ({ opened, onClose, arrivalDate, adults, reservationDetails }) => {
  const passCount = adults;
  const validDate = GwDatesWrapper.format(arrivalDate, DATE_FORMATS.shortMonthDayNumber);
  const seasonPassId = reservationDetails.data.seasonPass.id;
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`
  });

  const passesText = editCopyByReplaceMultipleStrings(COPY.FULL_DAY_PASSES_COUNT, {
    '<COUNT>': passCount,
    '<PASS>': passCount > 1 ? 'Passes' : 'Pass'
  });

  const seasonPassNameText = editCopyByReplaceMultipleStrings(COPY.SEASON_PASS_NAME, {
    '<SEASON_PASS_NAME>': reservationDetails?.data?.seasonPass?.name,
    '<SEASON_PASS_ID>': seasonPassId
  });

  return (
    <Modal isOpen={opened} onRequestClose={onClose} padding={0} width={isMobile ? '85%' : '466px'}>
      <Flex flexDirection="column">
        <ModalHeader>
          <ModalTitle>{COPY.DAY_PASS_SUMMARY_TITLE}</ModalTitle>
          <CloseButton onClick={onClose}>
            <Flex alignItems="center">
              <CloseIcon color={theme.colors.preciousStoneBlue[100]} />
            </Flex>
          </CloseButton>
        </ModalHeader>
        <ModalContent>
          <ContentContainer>
            <SummaryInfoRow>
              <InfoColumn>
                <Text fontSize={0} color="deepLakeBlue.80" fontWeight="medium" mb={2}>
                  {COPY.NUMBER_OF_DAY_PASSES}
                </Text>
                <Text fontSize={4} color="deepLakeBlue.100" fontWeight="bold">
                  {passCount}
                </Text>
              </InfoColumn>
              <InfoColumn>
                <Text fontSize={0} color="deepLakeBlue.80" fontWeight="medium" mb={2}>
                  {COPY.VALID_ON}
                </Text>
                <Text fontSize={4} color="deepLakeBlue.100" fontWeight="bold">
                  {getDateMonthDayFormat(validDate)}
                </Text>
              </InfoColumn>
            </SummaryInfoRow>
            <ModalBody>
              <PassDetailsRow>
                <Text fontSize={1} color="deepLakeBlue.100" fontWeight="bold">
                  {COPY.FULL_DAY_RETAIL_WATER_PARK_PASS}
                </Text>
                <Text fontSize={1} color="deepLakeBlue.100" fontWeight="bold">
                  {COPY.ZERO_AMOUNT}
                </Text>
              </PassDetailsRow>
              <Text fontSize={1} color="deepLakeBlue.80" fontWeight="medium" mb={2}>
                {passesText}
              </Text>
              {/* Season Pass Applied */}
              <SeasonPassRow>
                <Text fontSize={1} color="deepForestGreen.100" fontWeight="semibold">
                  {seasonPassNameText}
                </Text>
                <AppliedContainer>
                  <CheckIcon color={theme.colors.successGreen} size="16px" />
                  <Text fontSize={1} color="deepForestGreen.100" fontWeight="semibold">
                    {COPY.APPLIED}
                  </Text>
                </AppliedContainer>
              </SeasonPassRow>
              {/* Total */}
              <TotalRow>
                <Text fontSize={3} color="deepLakeBlue.100" fontWeight="bold">
                  {COPY.TOTAL}
                </Text>
                <Text fontSize={3} color="deepLakeBlue.100" fontWeight="bold">
                  {COPY.ZERO_AMOUNT}
                </Text>
              </TotalRow>
            </ModalBody>
          </ContentContainer>
        </ModalContent>
      </Flex>
    </Modal>
  );
};

SeasonPassDayPassSummary.propTypes = propTypes;
SeasonPassDayPassSummary.defaultProps = {
  opened: false
};

const mapStateToProps = state => {
  const reservationDetails = state.entities.manageReservationDetails;

  return {
    adults: getAdults(reservationDetails),
    arrivalDate: getArrivalDate(reservationDetails),
    reservationDetails: reservationDetails
  };
};

export default connect(mapStateToProps, null)(SeasonPassDayPassSummary);
